import { useCallback, useMemo, useRef, useState } from 'react';
import { TrackChanges } from '@sierralabs/track-changes';
export function useTrackChanges(initial) {
    const initialRef = useRef(initial);
    const [trackChanges, setTrackChanges] = useState(new TrackChanges(initial));
    const [final, setFinal] = useState(initial);
    const history = trackChanges.history;
    const restart = useCallback((initial) => {
        initialRef.current = initial;
        setTrackChanges(new TrackChanges(initial));
        setFinal(initial);
    }, []);
    const updateState = useCallback((delta) => {
        setFinal(trackChanges.copy());
        return delta;
    }, [trackChanges]);
    const get = useCallback((path) => {
        return trackChanges.get(path);
    }, [trackChanges]);
    const insert = useCallback((path, newValue) => updateState(trackChanges.insert(path, newValue)), [trackChanges, updateState]);
    const move = useCallback((path, sourceIndex, destinationIndex) => updateState(trackChanges.move(path, sourceIndex, destinationIndex)), [trackChanges, updateState]);
    const update = useCallback((path, newValue) => updateState(trackChanges.update(path, newValue)), [trackChanges, updateState]);
    const remove = useCallback((path) => updateState(trackChanges.remove(path)), [trackChanges, updateState]);
    const undo = useCallback(() => {
        const result = trackChanges.undo();
        setFinal(trackChanges.copy());
        return result;
    }, [trackChanges]);
    const redo = useCallback(() => {
        const result = trackChanges.redo();
        setFinal(trackChanges.copy());
        return result;
    }, [trackChanges]);
    const commit = useCallback(() => {
        return trackChanges.commit();
    }, [trackChanges]);
    const uncommit = useCallback(() => {
        return trackChanges.uncommit();
    }, [trackChanges]);
    return useMemo(() => ({
        restart,
        final,
        instance: trackChanges.final,
        setFinal,
        initial: initialRef.current,
        history,
        get,
        insert,
        move,
        remove,
        delete: remove,
        update,
        undo,
        redo,
        commit,
        uncommit
    }), [
        restart,
        commit,
        final,
        trackChanges.final,
        history,
        get,
        insert,
        move,
        redo,
        remove,
        uncommit,
        undo,
        update
    ]);
}
//# sourceMappingURL=useTrackChanges.js.map